import { reservationBannerStatus } from '@/libs/ReservationHelper';
import { useAppContext } from '@/store/context';
import type { Company, Reservation } from '@/store/models/models';

export const useReservationBannerStatus = (
  company?: Company,
  reservation?: Reservation,
) => {
  const { isChekinRequired, isChekinEnabled, isChekinLoading } =
    useAppContext();

  return reservationBannerStatus(company, reservation, {
    isChekinRequired,
    isChekinEnabled,
    isChekinLoading,
  });
};
